import { TransactionItemType, TransactionType } from '@/types/Transaction';
// import iconTransactionBank from '@/assets/img/icon_transaction_bank@2x.png';
// import iconTransactionCard from '@/assets/img/icon_transaction_card@2x.png';
import iconTransactionBank from '@/assets/img/cb_ic_withdraw@2x.png';
import iconTransactionCard from '@/assets/img/cb_ic_topup@2x.png';
import { callbackDataType } from './types';
import { getTrans, formatPrice } from '@/utils/tools';
import { Transaction as TransactionTS } from '@/utils/constants';

export function getTitle(type: TransactionType, transaction: any) {
  if (type === TransactionType.Topup) {
    // @MARK transify key
    return `${getTrans(TransactionTS.labelTopupPrefix, 'From')} ${transaction.payment_channel_text}`;
  }

  if (type === TransactionType.Withdrawal) {
    // @MARK transify key
    return `${getTrans(TransactionTS.labelWithdrawalPrefix, 'To Bank')} ${transaction.bank_name}`;
  }
}

function getIcon(type: TransactionType) {
  if (type === TransactionType.Topup) {
    return iconTransactionCard;
  }
  if (type === TransactionType.Withdrawal) {
    return iconTransactionBank;
  }
}

export function mapDataToTransaction(type: TransactionType, transaction: TransactionItemType): callbackDataType {
  return {
    title: getTitle(type, transaction) || '',
    amount: `${type === TransactionType.Topup ? '+' : '-'}${formatPrice(transaction.amount)}`,
    image: getIcon(type),
    specification: transaction.create_time,
    status: transaction.status,
  };
}
